import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useId } from 'react';
import { MembershipRole } from '@/types/api/membership';
import MembershipRoleBadge from './membership-role-badge';

interface MembershipRoleSelectProps {
  value: MembershipRole;
  onChange: (value: MembershipRole) => void;
}

export default function MembershipRoleSelect({ value, onChange }: MembershipRoleSelectProps) {
  const id = useId();
  return (
    <div className="*:not-first:mt-2">
      <Label htmlFor={id}>Medlemsroll</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger id={id} className="!px-0 !border-none">
          <SelectValue placeholder="Välj medlemsroll" />
        </SelectTrigger>
        <SelectContent>
          {Object.values(MembershipRole).map((role) => (
            <SelectItem value={role}>
              <MembershipRoleBadge role={role} />
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
